import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import { pages, howWeWork } from '@/content/site'
import { impressum, datenschutz } from '@/content/legal'
import { idpIntegration, paymentProviderIntegration } from '@/content/integrations'

const AboutPage = () => import(/* webpackChunkName: "about" */ '@/views/AboutPage.vue')
const HowWeWorkPage = () => import(/* webpackChunkName: "how-we-work" */ '@/views/HowWeWorkPage.vue')
const EngagementPhasePage = () =>
  import(/* webpackChunkName: "engagement-phase" */ '@/views/EngagementPhasePage.vue')
const ExperiencePage = () => import(/* webpackChunkName: "experience" */ '@/views/ExperiencePage.vue')
const PitchPage = () => import(/* webpackChunkName: "pitch" */ '@/views/PitchPage.vue')
const OnboardingPage = () => import(/* webpackChunkName: "onboarding" */ '@/views/OnboardingPage.vue')
const OnboardingSharedPage = () =>
  import(/* webpackChunkName: "onboarding" */ '@/views/OnboardingSharedPage.vue')
const ContactPage = () => import(/* webpackChunkName: "contact" */ '@/views/ContactPage.vue')
const PlaceholderPage = () => import(/* webpackChunkName: "placeholder" */ '@/views/PlaceholderPage.vue')
const LegalDocumentPage = () =>
  import(/* webpackChunkName: "legal" */ '@/views/LegalDocumentPage.vue')
const IntegrationInfoPage = () =>
  import(/* webpackChunkName: "integrations" */ '@/views/IntegrationInfoPage.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/experience',
    name: 'experience',
    component: ExperiencePage,
  },
  {
    path: '/demos',
    redirect: '/experience',
  },
  {
    path: '/pitch',
    name: 'pitch',
    component: PitchPage,
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: OnboardingPage,
  },
  {
    path: '/onboarding/shared/:token',
    name: 'onboarding-shared',
    component: OnboardingSharedPage,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage,
  },
  {
    path: '/how-we-work',
    name: 'how-we-work',
    component: HowWeWorkPage,
  },
  {
    path: '/how-we-work/:phase',
    name: 'engagement-phase',
    component: EngagementPhasePage,
    beforeEnter(to) {
      const valid = howWeWork.process.steps.some((step) => step.slug === to.params.phase)
      if (!valid) return '/how-we-work'
    },
  },
  {
    path: '/approach',
    redirect: '/how-we-work',
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage,
  },
  {
    path: '/healthcare',
    name: 'healthcare',
    component: PlaceholderPage,
    props: pages.healthcare,
  },
  {
    path: '/startups',
    name: 'startups',
    component: PlaceholderPage,
    props: pages.startups,
  },
  {
    path: '/solutions/startups',
    redirect: '/startups',
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: LegalDocumentPage,
    props: { document: impressum },
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',
    component: LegalDocumentPage,
    props: { document: datenschutz },
  },
  {
    path: '/privacy',
    redirect: '/datenschutz',
  },
  {
    path: '/integrations/identity-provider',
    name: 'idp-integration',
    component: IntegrationInfoPage,
    props: { document: idpIntegration },
  },
  {
    path: '/integrations/payment-provider',
    name: 'payment-provider-integration',
    component: IntegrationInfoPage,
    props: { document: paymentProviderIntegration },
  },
]

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})